import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
import api from '@/api';
export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      activeName: 'platform',
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      users: [{
        name: 'Admin',
        username: 'admin',
        password: 'admin'
      }, {
        name: 'lptnyy',
        username: 'lptnyy',
        password: 'wangyang'
      }, {
        name: 'User1',
        username: 'user1',
        password: 'user1'
      }],
      // 表单
      formLogin: {
        username: '',
        password: '',
        code: 'v9am',
        loginType: 'back'
      },
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      setting: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({
    handleClick: function handleClick(tab, event) {
      if (tab.name === 'platform') {
        this.formLogin.loginType = 'back';
      } else if (tab.name === 'agent') {
        this.formLogin.loginType = 'agent';
      } else {
        this.formLogin.loginType = 'matchmaker';
      }
    },
    initSetting: function initSetting() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_SETTING_INFO({
                id: 1
              });
            case 1:
              _this2.setting = _context.v;
              localStorage.setItem('setting', JSON.stringify(_this2.setting.body));
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }, mapActions('d2admin/account', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this3 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          _this3.login({
            username: _this3.formLogin.username,
            password: _this3.formLogin.password,
            loginType: _this3.formLogin.loginType
          }).then(function () {
            // 重定向对象不存在则返回顶层路径
            _this3.$router.replace(_this3.$route.query.redirect || '/');
          });
        } else {
          // 登录表单校验失败
          _this3.$message.error('表单校验失败，请检查');
        }
      });
    }
  })
};